import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "bedFilled"
const BedFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M19.5 3.75C20.328 3.75 21 4.422 21 5.25V11.452C21.448 11.712 21.75 12.195 21.75 12.75V20.25H20.25V18H3.75V20.25H2.25V12.75C2.25 12.195 2.552 11.712 3 11.452V5.25C3 4.422 3.672 3.75 4.5 3.75zM6 8.813C5.068 8.813 4.313 9.568 4.313 10.5V11.25C4.313 11.354 4.396 11.438 4.5 11.438H11.25C11.354 11.438 11.438 11.354 11.438 11.25V10.5C11.438 9.568 10.682 8.813 9.75 8.813zM14.25 8.813C13.318 8.813 12.563 9.568 12.563 10.5V11.25C12.563 11.354 12.646 11.438 12.75 11.438H19.5C19.604 11.438 19.688 11.354 19.688 11.25V10.5C19.688 9.568 18.932 8.813 18 8.813z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default BedFilledIcon
